import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-topic",
  "use": "icon-topic-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-topic\"><path d=\"M0 0l341.341 93.09L682.66 0 1024 93.09V1024l-341.341-93.09L341.34 1024 0 930.91V0z m93.09 859.81l248.251 67.701 341.318-93.09 248.25 67.7V164.189l-248.25-67.7-341.318 93.09-248.25-67.7v737.932z m209.455-580.537h93.091v558.545h-93.09V279.273z m325.819 46.545h93.09v372.364h-93.09V325.818z\" fill=\"#dbdbdb\" p-id=\"6234\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/topic.svg
// module id = rNYf
// module chunks = 112